import {AnyAction} from 'redux';
import {SET_SEARCH_USERS} from '../actionTypes';

export interface UsersState {
  searchUsers: any[];
}

const initialState: UsersState = {
  searchUsers: [],
};

export default (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case SET_SEARCH_USERS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
